module.exports = __webpack_public_path__ + "img/rabbits.5bb1c84.png";